// Custom code for PDP product description read more
const cardDescription = document.querySelectorAll(".product__description p");
const readMoreButton = document.querySelector(".read-more");

if (readMoreButton) {
  readMoreButton.addEventListener("click", function () {
    cardDescription.forEach(el => {
    el.classList.toggle("expanded");
    readMoreButton.textContent = el.classList.contains("expanded")
      ? "Read less"
      : "Read more";
    });
  });
}
// Custom code for PDP product description read more ends here

// Custom code to pass the value of quantity selector to the sticky ATC button form            
function passValue(val) {
  let updatedQuantity = val;
  // console.log("updatedQuantity", updatedQuantity);
  document.querySelector('[data-quantity-input="sticky_cart"]').value = updatedQuantity;
} 
// Custom code to pass the value of quantity selector to the sticky ATC button form ends here

// Custom code to scroll down to judgeme reviews widget from review container
document.addEventListener('DOMContentLoaded', function() {
  var ratingContainer = document.querySelector('.product-rating-container');
  if (!ratingContainer) return;
  ratingContainer.addEventListener('click', function() {
    var targetElement = document.getElementById('judgeme_product_reviews')
      || document.querySelector('.jdgm-widget')
      || document.querySelector('[data-judgeme]')
      || document.querySelector('.shopify-section-judgeme_preview_badge_element');
    if (!targetElement) return;
    var offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - 120;
    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
  });
});
// Custom code to scroll down to judgeme reviews widget from review container ends here

document.querySelectorAll('a[href="#judgeme_product_reviews"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      const target = document.querySelector('#judgeme_product_reviews');

      if (target) {
        const offset = 120; // sticky header height
        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
          top: top,
          behavior: 'smooth'
        });
      }
    });
  });

// Custom code to lazy load judgeme product review img
const judgeme_image = document.querySelector('#judgeme_product_reviews .jdgm-rev img');
if (judgeme_image) {
  judgeme_image.setAttribute('loading', 'lazy');
  judgeme_image.setAttribute('fetchpriority', 'low');
}
// Custom code to lazy load judgeme product review img ends here

// Custom code to update product title and secondary title on variant change
document.addEventListener('variant:change', function(evt) {
  var v = evt.detail && evt.detail.variant;
  if (!v) return;
  var title = (typeof variant_title !== 'undefined' && variant_title[v.id]) || v.title;
  if (title && title !== 'Default Title') {
    document.querySelectorAll('[data-variant-title]').forEach(function(el) {
      el.textContent = title;
    });
  }
  document.querySelectorAll('.secondary_title').forEach(function(el) {
    el.innerHTML = evt.detail.variantSecondaryTitle;
  });
});
// Custom code to update product title on variant change ends here

// Sticky media gallery — 0px top on scroll down, 100px on scroll up
(function () {
  if (window.innerWidth < 990) return;

  const product = document.querySelector('.product:not(.product--no-media)');
  if (!product) return;

  let lastScrollY = window.scrollY;

  window.addEventListener('scroll', function () {
    const y = window.scrollY;
    const isScrollingUp = y < lastScrollY;
    lastScrollY = y;

    requestAnimationFrame(function () {
      product.style.setProperty('--pdp-sticky-top', isScrollingUp ? '100px' : '0px');
    });
  }, { passive: true });
})();
